module.exports = __webpack_public_path__ + "img/image_17.b1fa33ef.png";